export default __webpack_public_path__ + "static/FS2S-InHub-180-3e1ab267ac8cecc7a8f2431fd0683cc1.jpg";